<template>
  <div class="md:flex flex-wrap -mx-2">
    <template v-for="(field, index) in config">
      <p class="px-2 w-full uppercase text-xs text-gray-600 font-medium" :key="index" v-if="field.component === 'title'">{{ field.title }}</p>
      <hr class="mx-2 my-4 w-full" :key="index" v-if="field.component === 'separator'" />
      <p class="px-2" :key="index" v-if="field.component === 'helper'" :class="field.css" v-html="field.label"></p>
      <div
        v-if="isVisible(field) && field.component !== 'title' && field.component !== 'separator' && field.component !== 'helper'"
        :key="index"
        class="relative p-2"
        :class="getWidth(field)">
        <slot :name="getSlotName(field)" :field="field">
          <dynamic-field
            v-model="value[field.modelKey]"
            :class="field.css"
            :component="field.component"
            :label="field.label"
            :name="field.name"
            :placeholder="field.placeholder"
            :type="field.type"
            :error="getError(field)"
            :options="field.options"
            :config="field.config"
            :title="field.title"
            :value-getter="field.valueGetter"
            :label-getter="field.labelGetter"
            :checked-label="field.checkedLabel"
            :unchecked-label="field.uncheckedLabel"
            :icon="field.icon"
            :underlined="field.underlined"
            :inline="field.inline"
            :switch="field.switch"
            :dropdown="field.dropdown"
            :disabled="field.disabled"
            :readonly="field.readonly"
            :position="field.position"
            :separator="field.separator"
            :required="field.required"
            :rows="field.rows"
            :min-rows="field.minRows"
            :max-rows="field.maxRows"
            :add-label="field.addLabel"
            :disable-weekends="field.disableWeekends"
            :disable-passed-dates="field.disablePassedDates"
            :enable-limit="field.enableLimit"
            @change="onChange('change', $event, field)"
            @file-change="onChange('file-change', $event, field)"
            @debounce="onChange('debounce', $event, field)"
            @submit="onChange('submit', $event, field)"
          ></dynamic-field>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
import DynamicField from './DynamicField'

export default {
  components: {
    DynamicField
  },
  props: {
    value: Object,
    config: Array,
    errors: [Array, Object]
  },
  methods: {
    capitalize(s) {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    },
    getSlotName(field) {
      return `field(${field.modelKey})`
    },
    getError(field) {
      return this.errors ? this.errors[field.modelKey] : null;
    },
    getWidth(field) {
      return field.hasOwnProperty("width") ? field.width : "w-full";
    },
    isVisible (field) {
      return field.condition ? field.condition() : true
    },
    onChange (key, event, field) {
      if (field.hasOwnProperty(`on${this.capitalize(key)}`)) {
        field[`on${this.capitalize(key).replace('-', '')}`](event)
      }
      this.$emit(key, {
        data: event,
        modelKey: field.modelKey
      })
    }
  }
};
</script>
